import React from "react";
import style from "./style.module.scss";
import moment from "moment/moment";
import { formatCurrency } from "../../../../../../../../components/helper/helper";
import DollarSign24 from "../../../../../../../assets/svg/icons/common/DollarSign24";
import CheckMarkCircleGreen13 from "../../../../../../../assets/svg/icons/common/CheckMarkCircleGreen13";

function ChildTableRow({ data, lastRow }) {
  return (
    <tr className={`${style.line} ${!lastRow ? style.line_after : ""}`}>
      <td className={style.child_table_cell}>
        <div className={style.align_center}>
          <DollarSign24 />
          {data?.card_type}
        </div>
      </td>
      <td className={style.child_table_cell}>
        <div className={style.align_center}>
          <CheckMarkCircleGreen13 />
          {data?.code}
        </div>
      </td>
      <td className={`${style.child_table_cell} ${style.date_cell}`}>
        {moment(data?.transaction_date).format("MM/DD/YYYY")}
        <span className={style.time}>{moment(data?.transaction_date).format("HH:mm")}</span>
      </td>
      <td className={style.child_table_cell}>{data?.key_entry}</td>
      <td className={style.child_table_cell}>{data.cardholder_acct_number}</td>
      <td className={style.child_table_cell}>{data?.authorization_number}</td>
      <td className={`${style.child_table_cell} ${style.reference_number}`}>
        {data?.reference_number?.toString().replace(/(\d{4})(?=\d)/g, '$1 ')}
      </td>
      <td className={style.child_table_cell}>{data?.voucher}</td>
      <td className={style.child_table_cell}>{data?.trans_amt ? `$ ${formatCurrency(data?.trans_amt)}` : '0'}</td>
      <td className={style.child_table_cell}>{data?.net_amt ? `$ ${formatCurrency(data?.net_amt)}` : '0'}</td>
      <td className={style.child_table_cell}>{data?.adj_amt ? `$ ${formatCurrency(data?.adj_amt)}` : '0'}</td>
    </tr>
  );
}

export default ChildTableRow;
